import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ProductType } from '../_models/product_type';
import { ProductTypesService } from '../_services/product-types.service';

@Component({
  selector: 'app-product-types',
  templateUrl: './product-types.component.html',
})
export class ProductTypesComponent implements OnInit, OnDestroy {
  productTypes: ProductType[];
  loading: boolean = true;

  subscriptions: Subscription[] = [];

  constructor(
    private productTypesService: ProductTypesService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    this.updateProductTypesList();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messageService.clear();
  }

  // * Delete product === //
  onDeleteProductType(event: Event, productTypeId: number) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Da li ste sigurni da želite da obrišete tip?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.productTypesService.deleteProductType(productTypeId).subscribe(
          () => {
            this.messageService.add({
              key: 'br',
              severity: 'success',
              summary: 'Uspešno brisanje',
              detail: 'Obrisali ste tip.',
            });
            this.updateProductTypesList();
          },
          (error) => {
            const errorObj = error.error.errors;
            const messService = this.messageService;
            Object.keys(errorObj).forEach(function (key) {
              messService.add({
                severity: 'error',
                sticky: true,
                key: 'br',
                summary: 'Greška',
                detail: errorObj[key],
              });
            });
          }
        );
      },
    });
  }

  // * Helpers === //
  private updateProductTypesList() {
    this.loading = true;
    this.subscriptions.push(
      this.productTypesService
        .getAllProductTypes()
        .subscribe((productTypes) => {
          this.productTypes = productTypes;
          this.loading = false;
        })
    );
  }
}
